import { useState } from 'react';
import { useDeleteRawContactMutation } from '../../../../../services/cellcast.v2';
import { toast } from 'react-toastify';
import { useI18n } from '../../../../Utils/_helpers/useI18n';

export const useContactDelete = (onSuccess?: () => void) => {
  const [isDeleting, setIsDeleting] = useState(false);
  const [deleteContact] = useDeleteRawContactMutation();
  const { t } = useI18n();

  const handleDeleteContacts = async (contactIds: string[]) => {
    if (!contactIds.length) {
      toast.error(t('RAW_CONTACT_COLLECTION.NO_CONTACTS_SELECTED'));
      return false;
    }

    try {
      setIsDeleting(true);
      
      // Process the request
      const response = await deleteContact({ ids: contactIds }).unwrap();
      const message = response?.message;
      
      toast.success(message);
      
      // Call success callback if provided
      if (onSuccess) {
        onSuccess();
      }
      
      return true;
    } catch (error:any) {
      // Handle error
      toast.error(error?.data?.message || t('RAW_CONTACT_COLLECTION.DELETE_ERROR'));
      return false;
    } finally {
      setIsDeleting(false);
    }
  };

  return {
    handleDeleteContacts,
    isDeleting
  };
}; 